import API from "apiInstance";
import { toast } from "react-toastify";

export const ngoWalletAmount = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/transaction/",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const ngoTransactionCount = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/transaction/count-per-ngo",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const ngoTransactions = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/transaction/all-per-ngo",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
